/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allow_Merge_Brief_EventsInputs */

const en_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow merging of brief events`)
};

const fr_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser la fusion des événements brefs`)
};

const de_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen kurzer Ereignisse erlauben`)
};

const it_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenti l'unione di eventi brevi`)
};

const ru_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешить объединение коротких событий`)
};

const es_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir la fusión de eventos breves`)
};

const zh_cn2_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许合并短事件`)
};

const ja_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短いイベントの結合を許可`)
};

const hi_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त घटनाओं के विलय की अनुमति दें`)
};

const pt_pt2_allow_merge_brief_events = /** @type {(inputs: Allow_Merge_Brief_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir a fusão de eventos breves`)
};

/**
* | output |
* | --- |
* | "Allow merging of brief events" |
*
* @param {Allow_Merge_Brief_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const allow_merge_brief_events = /** @type {((inputs?: Allow_Merge_Brief_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allow_Merge_Brief_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_allow_merge_brief_events(inputs)
	if (locale === "de") return de_allow_merge_brief_events(inputs)
	if (locale === "it") return it_allow_merge_brief_events(inputs)
	if (locale === "ru") return ru_allow_merge_brief_events(inputs)
	if (locale === "es") return es_allow_merge_brief_events(inputs)
	if (locale === "zh-CN") return zh_cn2_allow_merge_brief_events(inputs)
	if (locale === "ja") return ja_allow_merge_brief_events(inputs)
	if (locale === "hi") return hi_allow_merge_brief_events(inputs)
	if (locale === "pt-PT") return pt_pt2_allow_merge_brief_events(inputs)
	return en_allow_merge_brief_events(inputs)
});